import { render, staticRenderFns } from "./Occupation.vue?vue&type=template&id=52e03ea2&"
import script from "./Occupation.vue?vue&type=script&lang=js&"
export * from "./Occupation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e03ea2')) {
      api.createRecord('52e03ea2', component.options)
    } else {
      api.reload('52e03ea2', component.options)
    }
    module.hot.accept("./Occupation.vue?vue&type=template&id=52e03ea2&", function () {
      api.rerender('52e03ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/Occupation.vue"
export default component.exports